export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/923212341247"
      className="fixed bottom-6 right-6 z-50  text-white p-4 rounded-full shadow-lg transition duration-300 flex items-center justify-center"
      target="_blank"
      rel="noopener noreferrer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M20.52 3.48A11.8 11.8 0 0 0 12 .2 11.8 11.8 0 0 0 3.48 3.48 11.8 11.8 0 0 0 .2 12c0 2.12.55 4.17 1.6 5.98L0 24l6.22-1.55a11.8 11.8 0 0 0 5.78 1.47h.01c6.52 0 11.8-5.28 11.8-11.8a11.8 11.8 0 0 0-3.3-8.64zM12 21.6c-1.8 0-3.56-.48-5.1-1.39l-.36-.21-3.69.92.99-3.6-.23-.37A9.77 9.77 0 0 1 2.4 12c0-5.33 4.27-9.6 9.6-9.6 2.56 0 4.97 1 6.78 2.82A9.53 9.53 0 0 1 21.6 12c0 5.33-4.27 9.6-9.6 9.6zm5.13-7.2c-.28-.14-1.65-.81-1.91-.9-.26-.1-.45-.14-.64.14-.19.28-.73.9-.9 1.08-.17.19-.35.21-.64.07-.28-.14-1.18-.44-2.25-1.4-.83-.74-1.4-1.65-1.57-1.93-.16-.28-.02-.43.12-.57.12-.12.28-.3.42-.45.14-.14.18-.24.28-.4.1-.17.05-.3-.02-.43-.07-.14-.64-1.55-.88-2.13-.23-.55-.47-.48-.64-.49h-.55c-.19 0-.43.06-.66.3-.23.23-.87.85-.87 2.06 0 1.21.9 2.38 1.02 2.55.14.17 1.76 2.7 4.27 3.79 2.51 1.09 2.51.73 2.96.69.45-.04 1.47-.6 1.68-1.18.21-.57.21-1.07.14-1.18-.07-.1-.26-.17-.55-.31z"/>
      </svg>
    </a>
  );
}
